<template>
  <v-row>
    <v-col
      sm="1"
      lg="2"
      class="hidden-xs-only"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            exact
            color="primary"
            v-bind="attrs" 
            v-on="on" 
            @click="regresar"
          >
            <v-icon>
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>

    <v-col 
      cols="12" 
      sm="10" 
      lg="8"
    >
      <DetailCard
        title="Detalles Cupo"
        :loading="cardLoading"
      >
        <v-row justify="center">

          <v-col cols="12" sm="10" lg="8">
            <p class="text-h6 font-weight-bold">
              Competencia
            </p>
            <template v-if="cupo.competencia != null">
              <p class="text-subtitle-1">
                {{ cupo.competencia }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col cols="12" sm="10" lg="8">
            <p class="text-h6 font-weight-bold">
              Saber
            </p>
            <template v-if="cupo.saber != null">
              <p class="text-subtitle-1">
                {{ cupo.saber }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrado
              </p>
            </template>
          </v-col>

          <v-col cols="12" sm="10" lg="8">
            <p class="text-h6 font-weight-bold">
              Descripción
            </p>
            <template v-if="cupo.descripcion != null">
              <p class="text-subtitle-1">
                {{ cupo.descripcion }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col cols="12" sm="10" lg="8">
            <p class="text-h6 font-weight-bold">
              Modalidad
            </p>
            <template v-if="cupo.modalidad != null">
              <p class="text-subtitle-1">
                {{ cupo.modalidad }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col cols="12" sm="10" lg="8">
            <p class="text-h6 font-weight-bold">
              Cupos
            </p>
            <template v-if="cupo.numero_participantes != null">
              <p class="text-subtitle-1">
                {{ cupo.numero_participantes }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrados
              </p>
            </template>
          </v-col>

        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>

<script>
import DetailCard from '../../../components/admin/DetailCard.vue';

export default {
  data: () => ({
    cardLoading: true
  }),

  components: {
    DetailCard
  },

  mounted() {
    this.$store.dispatch("obtenerCupoCampesenaId", this.$route.params.idCupo);
    setTimeout(() => {
      this.cardLoading = false;
    }, 1000);
  },

  computed: {
    cupo() {
      return this.$store.getters.obtenerCupoCampesena;
    }
  },

  methods: {
    regresar() {
      this.$router.back();
    }
  }
};
</script>
